import { Dispatch, SetStateAction, useState } from 'react';

import { useDeleteMessageCategories } from 'modules/dragAndDropEditor/hooks/useDeleteMessageCategories';
import {
  CategoriesFieldArray,
  CategoryFieldToDelete,
  ManageCustomCategoriesConfirmationType,
} from '../ManageCustomCategoriesModal.types';

export const useProcessCategoryDeletion = (
  fieldArray: CategoriesFieldArray,
  setManageCustomCategoriesConfirmationType: Dispatch<
    SetStateAction<ManageCustomCategoriesConfirmationType>
  >,
) => {
  const [categoryToDelete, setCategoryIdToDelete] = useState<CategoryFieldToDelete>();
  const { isLoading: isDeletingCategory, deleteMessageCategories } = useDeleteMessageCategories();

  const initiateCategoryDeletionProcess = (category: CategoryFieldToDelete) => {
    // If the category doesn't have an id, it means it's a new category and we can remove it from the form directly
    if (!category?.categoryId) {
      fieldArray?.remove(category?.index);
    } else {
      setCategoryIdToDelete(category);
      setManageCustomCategoriesConfirmationType(
        ManageCustomCategoriesConfirmationType.DeleteCategory,
      );
    }
  };

  const resetCategoryDeletionProcess = () => {
    setCategoryIdToDelete(undefined);
    setManageCustomCategoriesConfirmationType(ManageCustomCategoriesConfirmationType.None);
  };

  const processCategoryDeletion = () => {
    deleteMessageCategories({
      variables: {
        delete: [{ id: categoryToDelete?.categoryId as number }],
      },
      onCompleted: (data) => {
        resetCategoryDeletionProcess(); // Reset the deletion process whether the request failed or not

        // If the data has the failure field, it means the deletion failed
        if (!data?.manageMessageCategories?.failure) {
          fieldArray?.remove(categoryToDelete?.index);
        }
      },
      onError: () => {
        resetCategoryDeletionProcess();
      },
    });
  };

  return {
    categoryToDelete,
    isDeletingCategory,
    processCategoryDeletion,
    initiateCategoryDeletionProcess,
    resetCategoryDeletionProcess,
  };
};
